import { PageViewEventLogger } from '@repo/tracking-service';
import { useAtomValue } from 'jotai';
import { ReactElement, useEffect } from 'react';
import { useQueryLoader } from 'react-relay';

import { businessPlaceTypeQuery } from '@/__generated__/businessPlaceTypeQuery.graphql';
import Spinner from '@/components/common/Spinner';
import { BusinessOfficeTypeContainer } from '@/components/survey/business/place-type/BusinessPlaceTypeContainer';
import { BusinessProvider } from '@/components/survey/common/BusinessProvider';
import { SurveyProvider } from '@/components/survey/common/SurveyProvider';
import { useSurveyUserEventAttributes } from '@/components/survey/common/hooks/use-survey-user-event-attributes';
import { officeTypeQuery } from '@/graphql/query/survey/business';
import { currentBusinessBmanTinAtom, refundHistoryIdAtom } from '@/lib/stores/survey/common';

function BusinessOfficeTypePage() {
  const eventAttributes = useSurveyUserEventAttributes();
  const [queryRef, loadQuery] = useQueryLoader<businessPlaceTypeQuery>(officeTypeQuery);
  const bmanTin = useAtomValue(currentBusinessBmanTinAtom);
  const refundHistoryId = useAtomValue(refundHistoryIdAtom);

  useEffect(() => {
    if (bmanTin && refundHistoryId) {
      loadQuery(
        {
          refundHistoryId,
          bmanTin
        },
        { fetchPolicy: 'network-only' }
      );
    }
  }, [loadQuery, bmanTin, refundHistoryId]);

  if (!queryRef) return <Spinner />;
  return (
    <PageViewEventLogger pageName={'survey_office'} eventProperty={eventAttributes}>
      <BusinessOfficeTypeContainer queryRef={queryRef} />
    </PageViewEventLogger>
  );
}

BusinessOfficeTypePage.getLayout = (page: ReactElement) => (
  <SurveyProvider>
    <BusinessProvider>{page}</BusinessProvider>
  </SurveyProvider>
);

export default BusinessOfficeTypePage;
